export default __webpack_public_path__ + "38e20369bc5de9fde95e7fd84bbe91a0.svg";